import { createFileRoute } from "@tanstack/react-router"
import AudioList from "~/components/Audio/AudioList"
import CustomHead from "~/components/SEOHead/CustomHead"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"

function AudioPage() {
  const { data: audioList } = api.audio.getPrivateAudio.useQuery()

  return (
    <AppLayout head={<CustomHead />}>
      <AudioList audioList={audioList ?? []} />
    </AppLayout>
  )
}

export const Route = createFileRoute("/audio")({
  component: AudioPage,
})
